import PropTypes from 'prop-types';
import React from 'react';

import { Media } from '$partials/media/index.js';
import { TagCloudSmall } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CarouselItemPrimaryTestimonialCarouselItemBlock = ({
    author = null,
    media = null,
    quote = null,
    tags = null
}) => {
    // render
    return (
        <div className='md:layout-container h-full'>
            <div className='md:layout-grid-negative-gutter h-full'>
                <div className='sm:h-full flex flex-wrap md:items-center'>
                    <div className='sm:h-full w-12/12 sm:w-6/12 md:w-5/12 order-1 sm:order-2 md:layout-grid-col-padding aspect-[4/3]'>
                        <figure className='h-full relative flex items-center md:-mr-60'>
                            <Media
                                { ...media }
                                buttonPlacement='left' />
                        </figure>
                    </div>

                    <div className='w-12/12 sm:w-6/12 md:w-7/12 order-2 sm:order-1'>
                        <div className='flex flex-wrap pb-60 pt-30 sm:py-80 md:py-160'>
                            <div className='hidden md:block md:w-1/7 md:layout-grid-col-padding' />

                            <div className='w-12/12 sm:w-12/12 md:w-4/7 px-20 sm:px-40 md:layout-grid-col-padding'>
                                <blockquote className='blockquote'>
                                    {quote && (
                                        <h3 className='type-style-3'>
                                            {quote}
                                        </h3>
                                    )}

                                    {author && (
                                        <cite className='block type-style-4 not-italic mt-30 md:mt-40'>
                                            {author}
                                        </cite>
                                    )}
                                </blockquote>

                                {tags?.length > 0 && (
                                    <div className='mt-40 md:mt-60'>
                                        <TagCloudSmall tags={tags} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

CarouselItemPrimaryTestimonialCarouselItemBlock.propTypes = {
    author: PropTypes.string.isRequired,
    media: PropTypes.object.isRequired,
    quote: PropTypes.string.isRequired,
    tags: PropTypes.array
};

export default CarouselItemPrimaryTestimonialCarouselItemBlock;
